import { Config } from '../config';
import { Policy, Permission } from '../interfaces';
import { HttpService } from './http.service';

interface UpdatePolicyInput extends Partial<Policy> {
  id: Policy['id'];
}

const path = `${Config.API}/access_policies`;

export abstract class PolicyService {
  public static getAllPolicies = (): Promise<Policy[]> => {
    return HttpService.fetchAuthorized(`${path}`).then((res) => {
      return res || [];
    });
  };

  public static getAllPermissions = (): Promise<Permission[]> => {
    return HttpService.fetchAuthorized(`${path}/permissions`).then((res) => {
      return res?.sort((a, b) => a.resource.localeCompare(b.resource)) || [];
    });
  };

  public static createPolicy = (body: Omit<Policy, 'id'>): Promise<any> => {
    return HttpService.fetchAuthorized(
      path,
      {
        method: 'POST',
        body: JSON.stringify(body),
      },
      undefined,
      true,
    ).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };

  public static deletePolicy = (id: string): Promise<any> => {
    return HttpService.fetchAuthorized(
      `${path}/${id}`,
      {
        method: 'DELETE',
      },
      undefined,
      true,
    ).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };

  public static updatePolicy = (body: UpdatePolicyInput): Promise<any> => {
    return HttpService.fetchAuthorized(
      `${path}/${body.id}`,
      {
        method: 'PUT',
        body: JSON.stringify(body),
      },
      undefined,
      true,
    ).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };
}
